/*
 * DataValue
 * @module components
 * @flow
 */

import React from 'react';
import * as R from 'ramda';
// $FlowIssue
import {
  FormattedNumber,
  type $npm$ReactIntl$NumberFormatOptions,
} from 'react-intl';

import { FRACTION_DIGITS } from '~/helpers';
import { Ellipsis } from '~/components';

export type DataValueProps = $npm$ReactIntl$NumberFormatOptions & {
  value?: number,
  percents?: boolean,
  isEmptyVisible?: boolean,
};

/**
 * DataValue React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {number} [props.value] - value
 * @param {boolean} [props.percents] - required to show percents
 * @param {boolean} [props.isEmptyVisible] - empty value visibility flag
 * @example <caption>Simple usage</caption>
 * <DataValue value={2} />
 * @returns {React.Node<*>} React-component
 */
export const DataValue = ({
  value,
  percents,
  isEmptyVisible,
  ...rest
}: DataValueProps) => {
  if (R.isNil(value) || Number.isNaN(value)) {
    return isEmptyVisible ? 0 : null;
  }

  return (
    <Ellipsis>
      <FormattedNumber
        minimumFractionDigits={0}
        maximumFractionDigits={percents ? 2 : FRACTION_DIGITS}
        value={value}
        {...rest}
      />
    </Ellipsis>
  );
};
